import { render, staticRenderFns } from "./MeetTeamCard.vue?vue&type=template&id=65153e42&scoped=true&"
import script from "./MeetTeamCard.vue?vue&type=script&lang=js&"
export * from "./MeetTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./MeetTeamCard.vue?vue&type=style&index=0&id=65153e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65153e42",
  null
  
)

export default component.exports